export default [
    {
        name: 'Béžové sandálky na nízkém sloupku',
        img: require('@/assets/newsletter-preview/1.jpg'),
        description: 'Béžové sandálky na nízkém sloupku jsou vyrobeny z eko semiše. Lze je využít i na slavnostnější příležitost. Vhodné na jaro a léto.',
        price: '327 Kč',
        originalPrice: '408 Kč',
        sale: 20
    },
    {
        name: 'Fuchsiové lodičky',
        img: require('@/assets/newsletter-preview/2.jpg'),
        description: 'Elegantní fuchsiové lodičky osvěží Váš šatník. Lodičky jsou vyrobené z eko semiše. Vhodné na jaro a léto.',
        price: '327 Kč',
        originalPrice: '545 Kč',
        sale: 40
    },
    {
        name: 'Klasické bíle tenisky',
        img: require('@/assets/newsletter-preview/3.jpg'),
        description: 'Klasické bíle tenisky jsou nepostradatelným doplňkem každého šatníku. Výběrem těchto tenisek prostě neuděláte chybu.  Tenisky jsou vyrobené z textilie a jsou vhodné na jaro a léto.',
        price: '199 Kč',
        originalPrice: '284 Kč',
        sale: 30
    },
    {
        name: 'Kožené boty na sloupku',
        img: require('@/assets/newsletter-preview/4.jpg'),
        description: 'V těchto červených botách na sloupku budete rafinovaně přitažlivá při každé příležitosti. Boty jsou vyrobeny z přírodní kůže s třpytivými detaily na sloupku boty.',
        price: '637 Kč',
        originalPrice: '850 Kč',
        sale: 25
    },
    {
        name: 'Lesklé nízké holínky',
        img: require('@/assets/newsletter-preview/5.jpg'),
        description: 'I za deště můžete působit elegantně v těchto nízkých holinkách. Šmrnc těm to holinkám dodává lesklé zpracování a výrazná guma v oblasti kotníků.',
        price: '391 Kč',
        originalPrice: '1303 Kč',
        sale: 70
    },
    {
        name: 'Lodičky s přezkou sergio leone',
        img: require('@/assets/newsletter-preview/6.jpg'),
        description: 'S těmi to výrazně červenými lodičkami budete hvězdou každého večírku.  Detail pásku v oblasti nártu Vám krásně zvýrazní linii nohy. Lodičky jsou vyrobeny z eko semiše. Vhodné na slavnostní příležitost.',
        price: '530 Kč',
        originalPrice: '883 Kč',
        sale: 40
    },
    {
        name: 'Kožené růžové lordsy',
        img: require('@/assets/newsletter-preview/7.jpg'),
        description: 'Kožené růžové lordsy s rafinovanou podrážkou jsou vhodné jak do města tak i na procházky do přírody. Vyrobené jsou z přírodní kůže. Boty jsou prodyšné. Vhodné na jaro a léto.',
        price: '530 Kč',
        originalPrice: '662 Kč',
        sale: 20
    },
    {
        name: 'Sneakersy s brokátem na platformě',
        img: require('@/assets/newsletter-preview/8.jpg'),
        description: 'Černobílé sneakersy na platformě jsou vyrobeny z eko kůže. Třpytivý detail v podrážce boty vytváří jedinečný dojem. Vhodné jsou jak do města tak do přírody.',
        price: '391 Kč',
        originalPrice: '488 Kč',
        sale: 20
    },
    {
        name: 'Stylové kozačky na sloupku',
        img: require('@/assets/newsletter-preview/9.jpg'),
        description: 'Ty to stylové kozačky na sloupku jsou v letošním roce trendem číslo jedna.  Kozačky jsou velice pohodlné a lze je kombinovat jak džinům tak sukni. Boty jsou vyrobeny z eko semiše v krásném béžovém odstínu.',
        price: '886 Kč',
        originalPrice: '1107 Kč',
        sale: 20
    },
    
    {
        name: 'Šněrovací polobotky ze semiše',
        img: require('@/assets/newsletter-preview/10.jpg'),
        description: 'Šněrovací polobotky ze semiše jsou vhodnou obuví pro ženy, které preferují pohodlný ale zároveň vkusný styl oblékání. U těchto bot byl použit eko semiš v černé barvě. Velice ležérní provedení Vám zaručí dobrou kombinovatelnost s Vaším šatníkem.',
        price: '391 Kč',
        originalPrice: '488 Kč',
        sale: 20
    },

]